import {
  isDesktopView,
  isMobileView,
  isTabletView,
} from "@evidenceb/athena-common/helpers/breakpoints";
import { useEffect, useState } from "react";

const useBreakpoints = () => {
  const [isMobile, setMobile] = useState(isMobileView());
  const [isTabletOrSmaller, setTablet] = useState(isTabletView());
  const [isDesktop, setDesktop] = useState(isDesktopView());

  useEffect(() => {
    const onWindowResize = () => {
      setMobile(isMobileView());
      setTablet(isTabletView());
      setDesktop(isDesktopView());
    };
    window.addEventListener("resize", onWindowResize);

    return () => {
      window.removeEventListener("resize", onWindowResize);
    };
  }, []);

  return {
    isMobile,
    isTabletOrSmaller,
    isDesktop,
  };
};

export default useBreakpoints;
